// Platform events the backend accepts (keep in sync with the server-side
// registry in server/entities/platform_events.py; unknown values are
// rejected with a 400).
export const PLATFORM_EVENT_TYPE_GROUPS: Array<{
  label: string;
  types: string[];
}> = [
  {
    label: 'Contact',
    types: [
      'contact.created',
      'contact.updated',
      'contact.deleted',
      'contact.state_changed',
    ],
  },
  {
    label: 'Campaign',
    types: ['campaign.started', 'campaign.stopped', 'campaign.deleted'],
  },
  {
    label: 'Task',
    types: ['task.created', 'task.status_changed', 'task.deleted'],
  },
  {
    label: 'Call',
    types: ['call.started', 'call.ended', 'voicemail.detected'],
  },
  {
    label: 'SMS',
    types: ['sms.sent', 'sms.received'],
  },
  {
    label: 'Email',
    types: ['email.sent', 'email.received'],
  },
];

export const ALL_PLATFORM_EVENT_TYPES: string[] =
  PLATFORM_EVENT_TYPE_GROUPS.flatMap(group => group.types);
